import { Principal } from "@dfinity/agent";
import { filter, map, get } from "lodash";
import axios from "axios";
import JSONBig from "json-bigint";
import { toast } from "react-toastify";
import { client } from "./agent";
// import CRC32 from "crc-32";
import {
  ListingType,
  PaymentMethodType,
} from "@origyn-sa/common-ui/src/api/types";
import { TradingHistoryItem } from "./types";

export function handleError(err: any) {
  console.error(err);
  toast.error(`Error: ${err}`);
}

export type ProductCardInput = {
  id: string;
  image: string;
  name: string;
  owner: string;
};

export const displayPrice = (item: any) =>
  item.listingPrice
    ? `${(
        Number(item.listingPrice) /
        10 ** Number(item.paymentMethod?.decimal || 0)
      ).toFixed(Number(item.paymentMethod?.decimal || 0))} ${
        item.paymentMethod?.name
      }`
    : "";

export const displayPriceFromListing = (
  item: ListingType,
  paymentMethod: PaymentMethodType
): string =>
  item.listingPrice && paymentMethod
    ? `${(
        Number(item.listingPrice) /
        10 ** Number(paymentMethod.decimal || 0)
      ).toFixed(Number(paymentMethod.decimal || 0))} ${
        paymentMethod.name || ""
      }`
    : "";

export const isDEBUG = process.env.NODE_ENV === "production" ? false : true;

export const getTokenUrl = (event: any) => {
  const tokenUriEntry = event.event;
  console.log(tokenUriEntry);
  return (
    tokenUriEntry.eventKind?.mintKind?.tokenURIEntry?.tokenURI ||
    tokenUriEntry.eventKind?.updateKind?.tokenURIEntry?.tokenURI
  );
};

export const getTokenOwner = (nftCanisterId: string, tokenId: string) => {
  const actor = client.getNewNftActor(nftCanisterId);
  return actor.ownerOf(tokenId);
};

export const fetchPaymentMethodsImpl = () => {
  return client.actor.getPaymentMethods().then((data: any) => {
    console.debug({ data });
    const pmtMore = data.map((pmT: any) => {
      console.debug({ pmT });
      const paymentMethodKind = Object.keys(pmT.kind)[0];
      switch (paymentMethodKind) {
        case "icpStandardKind":
          return [pmT, "ICP", 8];
        case "origynFTv1StandardKind":
          const ftApi = client.getNewFtActor(pmT._principal); // new CustomCanisterClient(pmT._principal);
          return Promise.all([
            pmT,
            ftApi.actor.symbol(),
            ftApi.actor.decimal(),
          ]);
        default:
          throw new Error(
            `Payment method kind not implemented for the UI: ${paymentMethodKind}`
          );
      }
    });
    return Promise.all(pmtMore).then((res: any) =>
      res.map((pmt: any) => ({
        ...pmt[0],
        name: pmt[1],
        decimal: pmt[2],
        _principal: pmt[0]._principal.toText(),
      }))
    );
  });
};

export const fetchPaymentMethods = () => {
  return fetchPaymentMethodsImpl().then((res: PaymentMethodType[]) => {
    return res;
  });
};

export const fetchNFTWallet = (
  nftCanisterId: string,
  principal: Principal
): Promise<any> => {
  const actor = client.getNewNftActor(nftCanisterId);
  return actor
    .tokensIdsOfOwner(principal)
    .then((data: Array<string>): Promise<any> => {
      const fetchItems: Promise<any>[] = [];
      console.log(data);
      data.forEach((id) => {
        fetchItems.push(fetchItemById(nftCanisterId, id));
      });

      return Promise.all(fetchItems)
        .then((items) => items)
        .catch((e) => {
          toast.error(e.message);
          return e;
        });
    });
};

export const fetchMarketItems = async (userPrincipal: string) => {
  console.debug("fetchMarketItems", userPrincipal);
  const req = client.actor
    .getCollections()
    .then(async (collectionsData: any) => {
      console.debug({ collectionsData });
      const filtered = collectionsData.filter((item: any) => item.enabled);
      console.log(filtered, collectionsData);
      const listingsCollectionsPromises = collectionsData.map((col: any) => {
        const listings = client.actor.getListingsForCollection(col._principal);
        // console.debug({ principal: col._principal.toText(), listings });
        return listings;
      });
      const listingsCollections = await Promise.all(
        listingsCollectionsPromises
      );
      console.log({ listingsCollections });

      const itemsRequests: Promise<any>[] = [];
      listingsCollections.forEach((listingsForOneCollection: any) =>
        // fetchNFTWallet(collection._principal, Principal.fromText(userPrincipal))
        {
          console.debug({ listingsForOneCollection });
          return listingsForOneCollection
            .filter((listing: any) => {
              console.debug({ listing });
              return listing.seller.toText() === userPrincipal;
            })
            .map((listing: any) => {
              console.debug({ listing });
              itemsRequests.push(
                fetchItemById(
                  listing.collectionItem.collectionPrincipal.toText(),
                  listing.collectionItem.identifier
                )
              );
            });
        }
      );

      return Promise.all(itemsRequests).then((i: any) => {
        console.debug({ i });
        if (i) {
          console.log(collectionsData);
          const itemsWithCanister = i.map((d: any, index: any) => ({
            ...d,
            canisterId: collectionsData[index]._principal,
          }));
          return itemsWithCanister.reduce((acc: any, item: any) => {
            console.log({ acc, item });
            return (acc = [...acc, item]);
          }, []);
        }
      });
    });
  return req;
};

export const fetchPaymentTypesBalance = (
  userPrincipal: string
): Promise<Array<any>> => {
  const req = client.actor.getPaymentMethods().then((data: any) => {
    const filtered = data.filter(
      (item: any) => item.enabled && item.kind?.origynFTv1StandardKind
    );

    const balanceRequests = filtered.map((paymentMethod: any) => {
      const actor = client.getNewFtActor(paymentMethod._principal); //new CustomCanisterClient(paymentMethod._principal);
      return Promise.all([
        actor.symbol(),
        actor.decimal(),
        actor.balanceOf(Principal.fromText(userPrincipal)),
      ]);
    });

    return Promise.all(balanceRequests).then((i: any) => {
      console.log(i, filtered);
      return filtered.map((pm: any, idx: any) => ({
        paymentMethod: pm,
        decimal: i[idx][1],
        symbol: i[idx][0],
        balance: Number(i[idx][2]),
      })); // TODO: dispatch to store
    });
  });
  return req;
};

export const fetchItemById = (
  nftCanisterId: string,
  id: string
): Promise<any> =>
  fetchTokenEvents(nftCanisterId, id).then((events: Array<any>) => {
    console.debug(nftCanisterId, id);
    console.log("getItemById", events);
    const mintEvent = events.find((event: any) =>
      get(event, "eventKind.mintKind")
    );
    const url = get(mintEvent, "eventKind.mintKind.tokenURIEntry.tokenURI");

    if (url) {
      return axios
        .get(url)
        .then(({ data }: any) => ({ ...data, id }))
        .catch((e: any) => {
          console.error(`Error! Token ${id} cant be fetched from externalURI!`);
        });
    }
    console.error(`Token with id: ${id} has no tokenURI!`);
    return null;
  });

export const fetchTokenEvents = (
  canisterId: string,
  id: string
): Promise<Array<any>> => {
  console.debug({ canisterId, id });
  const api = client.getNewNftActor(canisterId); //new CustomCanisterClient(canisterId);
  console.log(api);
  return api.eventsByTokenId(id);
};

export const fetchExploreItems = () => {
  console.log(client);
  const req = client.actor.getCollections().then((data: any) => {
    console.log("getCollections", data);
    const itemsRequests = data.map(
      ({
        _principal: principal,
        enabled,
      }: {
        _principal: Principal;
        enabled: boolean;
      }) => {
        if (!enabled) return null;
        return client.actor.getListingsForCollection(principal);
      }
    );
    return Promise.all(itemsRequests).then((i) => {
      console.log({ i });
      const allListings: Array<any> = [];
      i.forEach((listingsForCollectionResp: any) => {
        console.debug({ listingsForCollectionResp });
        if (listingsForCollectionResp)
          allListings.push(...listingsForCollectionResp);
      });
      console.debug({ allListings });
      const enrichedListingsPromises = allListings.map((al: any) => {
        console.debug({ al });
        return fetchItemById(
          al.collectionItem.collectionPrincipal,
          al.collectionItem.identifier
        );
      });
      console.log(enrichedListingsPromises);
      return Promise.all([
        Promise.all(enrichedListingsPromises),
        fetchPaymentMethodsImpl(),
      ])
        .then(([enrichedListingsResp, paymentsMethods]: any) => {
          console.debug({ enrichedListingsResp, paymentsMethods });
          const mergedStuff = allListings.map((al: any, idx: any) => {
            console.debug({ paymentsMethods, al });
            const pm = paymentsMethods.find(
              (pmI: PaymentMethodType) =>
                pmI._principal === al.paymentMethodPrincipal.toText()
            );
            return {
              ...al,
              ...enrichedListingsResp[idx],
              paymentMethod: pm,
              canisterId: al.collectionItem.collectionPrincipal,
            };
          });
          console.debug({ mergedStuff });
          return mergedStuff;
        })
        .catch(console.error);
    });
  });
  console.log("getCollections", req);
  return req;
};

export const getEventsByTokenId = (
  nftCanisterId: string,
  tokenId: string
): Promise<any> => {
  const actor = client.getNewNftActor(nftCanisterId);
  return actor.eventsByTokenId(tokenId);
};

export const filterTokenUriEvents = (events: any) => {
  return map(
    filter(events, (e) => e?.eventKind?.mintKind || e?.eventKind?.updateKind),
    (tokenUriEvent) => {
      console.debug({ tokenUriEvent });
      return {
        date: tokenUriEvent.time,
        event: tokenUriEvent,
      };
    }
  );
};

export const fetchTradingHistory = async () => {
  const index = await client.actor.getIndex();
  console.log(client);
  const req = client.actor
    .getEventRangeIndex(0, Math.max(Number(index) - 1, 0))
    .then((data: any) => {
      console.debug({ events: data });
      return data.reduce((acc: any, event: any) => {
        if (!event[0]) {
          return acc;
        }
        return acc.concat(event[0]);
      }, []);
    })
    .then((data: any) => {
      console.debug({ beforeDispatch: data });
      return data;
    })
    .then((data: any) =>
      data.map((d: any) => {
        const eventKind = Object.keys(d.eventKind)[0];
        const eventContent = d.eventKind[eventKind];
        const tradingHistory: TradingHistoryItem = {
          event: eventKind,
          item: "",
          price: "",
          from: eventContent?.caller?.toText(),
          to: "",
          id: d.index,
          date: new Date(Number(d.time) / 1000000).toUTCString(),
          raw: JSONBig.stringify(eventContent),
        };
        return tradingHistory;
      })
    )
    .then((data: Array<any>) => {
      return data;
    });
  return req;
};

export const fetchCollectionsSymbols = (
  collection: any[]
): Promise<Array<any>> => {
  const itemsRequests = collection.map(
    ({ _principal: principal }: { _principal: Principal }) => {
      const actor = client.getNewNftActor(principal.toText()); //new CustomCanisterClient(principal.toText());
      return actor.symbol();
    }
  );
  return Promise.all(itemsRequests).then((data: any) => {
    console.debug({ data });
    const withSymbols = collection.map((c, i) => ({
      ...c,
      symbol: data[i],
    }));
    return withSymbols;
  });
};

export const fetchCollections = () => {
  console.debug("fetchCollections");
  const req = client.actor.getCollections().then((data: any) => {
    console.debug("getCollections", data);
    return fetchCollectionsSymbols(data).then((collection) => {
      console.log({ collection, data });
      return collection;
    });
  });
  return req;
};

export const getLastTokenUri = async (
  nftCanisterId: string,
  tokenId: string
) => {
  const events = await getEventsByTokenId(nftCanisterId, tokenId);
  const uriEvents = filterTokenUriEvents(events);
  console.debug({ uriEvents });
  return getTokenUrl(uriEvents[0]);
};

export const transferNft = (
  nftCanisterId: string,
  tokenId: string,
  recipient: string,
  memo: string
) => {
  const actor = client.getNewNftActor(nftCanisterId);
  return actor.transfer(Principal.fromText(recipient), tokenId, memo);
};

export const approveNft = (
  nftCanisterId: string,
  tokenId: string,
  spender: string
) => {
  const actor = client.getNewNftActor(nftCanisterId);
  return actor.approve(Principal.fromText(spender), tokenId);
};

export const removeApproveNft = (
  nftCanisterId: string,
  tokenId: string,
  spender: string
) => {
  const actor = client.getNewNftActor(nftCanisterId);
  return actor.removeApproval(Principal.fromText(spender), tokenId);
};

// const longToByteArray = function(/*long*/long: number) {
//   // we want to represent the input as a 8-bytes array
//   var byteArray = [0, 0, 0, 0]; //, 0, 0, 0, 0];

//   for ( var index = 0; index < byteArray.length; index ++ ) {
//       var byte = long & 0xff;
//       byteArray [ index ] = byte;
//       long = (long - byte) / 256 ;
//   }

//   return byteArray;
// };

// export const principalToAccountIdentifier = (p: Principal) => {
//   const checksum = longToByteArray(CRC32.buf(pBlob))
//   const pBlob = p.toBlob()
//   var crypto = require('crypto');
//   //creating hash object
//   var hash = crypto.createHash('sha224');
//   const yo = [...checksum, ...pBlob]

//   return res
// }
